// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"CheckboxDiv_checkbox__2pqSr"};